const TOKEN_KEY = 'hmsAuthToken'

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY)

export const removeAuthToken = () => localStorage.removeItem(TOKEN_KEY)

export const setAuthToken = token => localStorage.setItem(TOKEN_KEY, token)
